import { render, staticRenderFns } from "./UserOther.vue?vue&type=template&id=771c2a44&scoped=true&"
import script from "./UserOther.vue?vue&type=script&lang=js&"
export * from "./UserOther.vue?vue&type=script&lang=js&"
import style0 from "./UserOther.vue?vue&type=style&index=0&id=771c2a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c2a44",
  null
  
)

export default component.exports